import React, { useCallback, useContext } from 'react';
import { PlayerUIContext, toggleModal } from '@24i/player-ui';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { StyledIcon as Icon } from '../../../Icons';
import { Button, Label } from './styled';
const RenderDefaultIcon = (buttonIconName, color, backgroundColor, styles) => (React.createElement(Icon, { style: styles.icon, name: buttonIconName, className: "ModalTriggeringButton-Icon", "data-test": "ModalTriggeringButton-Icon", color, backgroundColor }));
export const ModalTriggeringButton = ({ buttonIconName, associatedModalType, className = '', backgroundColor = 'transparent', color, disabledColor, customIcon = RenderDefaultIcon, disabled, styles = {
    button: null,
    icon: null,
}, children, testID, }) => {
    var _a, _b;
    const { dispatch } = useContext(PlayerUIContext);
    const onClick = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(toggleModal(associatedModalType));
    }, []);
    const { theme } = useTheme();
    const finalColor = color || ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.contrast1) || 'white';
    const finalDisabledColor = disabledColor || ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.contrast4) || 'gray';
    const iconColor = !disabled ? finalColor : finalDisabledColor;
    const idName = String(children).split(' ').join('_').toLowerCase();
    return (React.createElement(Button, { backgroundColor, disabled, onClick, style: styles.button, className: `ModalTriggeringButton ${className}`, "data-test": "ModalTriggeringButton", testID: testID !== null && testID !== void 0 ? testID : `${idName}_button`, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        } },
        customIcon(buttonIconName, iconColor, backgroundColor, styles),
        children && React.createElement(Label, { style: Object.assign({}, getFont(theme, 'h5')) }, children)));
};
//# sourceMappingURL=index.js.map